import { useContext } from 'react';
import ConfettiContext from 'src/contexts/ConfettiContext';

const useConfetti = () => useContext(ConfettiContext);

export default useConfetti;
